<template>
  <el-container >
    <el-header >
      <!--        <top-header @title-search="toChildMsg"/>-->
      <video-header @title-search="toChildMsg"/>
    </el-header>
    <el-main>
<!--      <video-detail v-bind:id="$route.params.id "/>-->
      <order-confirm v-bind:id="$route.params.id " />
    </el-main>
    <el-footer>
      <app-footer/>
    </el-footer>
  </el-container>
</template>

<script>
  import OrderConfirm from './orderConfirm'
  import {TopHeader,AppFooter,VideoHeader} from '@/layout/components'

  export default {
        name: "index",
        components: {TopHeader,AppFooter,OrderConfirm,VideoHeader},
    }
</script>

<style scoped>
  .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
  }
  .el-header{
    background-color: white;
    color: #333;
    text-align: center;
    height: 50px;
    position: fixed;
    width: 100%;
    z-index: 999;
    top: 0;
  }
  .el-footer{
    /*margin-top: 50px;*/
    position: relative;
    padding: 0px;
    text-align: left;
  }
  .el-main {
    /*background-color: #E9EEF3;*/
    color: #333;
    /*text-align: center;*/
    position: relative;
    margin-top: 50px;
    padding: 0px;
  }


  body > .el-container {
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/index.vue